// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "68280892aff16d1aecb0354a3aea85c9cb3c9625/static/css/" + chunkId + "." + "8ea9c403" + ".chunk.css";
};